import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Button, FullBar } from "cakemail-ui-components/lib/react";
import { Translate, I18n } from "react-redux-i18n";
import PropTypes from "prop-types";
import BrandElement from "assets/js/scenes/brand/components/brandElements/BrandElement";
import BrandColor from "assets/js/scenes/brand/components/brandElements/BrandColor";
import { showResetDialog } from "assets/js/scenes/brand/utils";

const basePath = "theme.base";
//const advancePath = "theme.advance";
//Will re-render all components to reset their state if this number changes
let key = new Date().getTime();
export const Colours = (props) => {
	const base = props.localBrand?.theme?.base;
	const defaultBase = props.brand?.theme?.base;
	//const advance = props.localBrand?.theme?.advance;

	function reset() {
		function resetConfirm() {
			props.resetTabData(basePath);
			key = new Date().getTime();
		}

		showResetDialog(
			<Translate value="app-brand-modal-tab-colors-reset" />,
			<p>
				<Translate
					value="app-brand-modal-tab-colors-reset-desc"
					resellerName={props.resellerName}
				/>
			</p>,
			resetConfirm
		);
	}

	return (
		<div className="brandModalTabContent Colours" key={key}>
			<FullBar
				className="tabContentTitleRow"
				left={
					<p className="h7">
						<Translate value="app-brand-modal-tab-colors-section-title" />
					</p>
				}
				right={
					<Button
						shapeStyle="stroke"
						colorTheme="grey"
						text={<Translate value="app-brand-modal-tab-colors-reset" />}
						onClick={reset}
					/>
				}
			/>

			<div className="brandElementsContainer">
				<BrandElement
					path={basePath + ".primary-brand-color"}
					title={<Translate value="app-brand-colour-primary-title" />}
					desc={<Translate value="app-brand-colour-default-desc" />}
					rightPanel={
						<BrandColor
							path={basePath + ".primary-brand-color"}
							color={base["primary-brand-color"]}
							defaultColor={defaultBase["primary-brand-color"]}
						/>
					}
				/>

				<BrandElement
					path={basePath + ".primary-brand-color-darken"}
					title={<Translate value="app-brand-colour-primary-darken-title" />}
					desc={<Translate value="app-brand-colour-secondary-darken-desc" />}
					rightPanel={
						<BrandColor
							path={basePath + ".primary-brand-color-darken"}
							color={base["primary-brand-color-darken"]}
							defaultColor={defaultBase["primary-brand-color-darken"]}
						/>
					}
				/>

				<BrandElement
					path={basePath + ".secondary-brand-color"}
					title={<Translate value="app-brand-colour-secondary-title" />}
					desc={<Translate value="app-brand-colour-default-desc" />}
					rightPanel={
						<BrandColor
							path={basePath + ".secondary-brand-color"}
							color={base["secondary-brand-color"]}
						/>
					}
					defaultColor={defaultBase["secondary-brand-color"]}
				/>
				<BrandElement
					path={basePath + ".secondary-brand-color-darken"}
					title={<Translate value="app-brand-colour-secondary-darken-title" />}
					desc={<Translate value="app-brand-colour-secondary-darken-desc" />}
					rightPanel={
						<BrandColor
							path={basePath + ".secondary-brand-color-darken"}
							color={base["secondary-brand-color-darken"]}
							defaultColor={defaultBase["secondary-brand-color-darken"]}
						/>
					}
				/>
			</div>

			<FullBar
				className="tabContentTitleRow"
				left={
					<p className="h7">
						<Translate value="app-brand-modal-tab-colors-font-section-title" />
					</p>
				}
			/>

			<div className="brandElementsContainer">
				<BrandElement
					path={basePath + ".body-font-color"}
					title={<Translate value="app-brand-colour-body-font-title" />}
					desc={<Translate value="app-brand-colour-default-desc" />}
					rightPanel={
						<BrandColor
							path={basePath + ".body-font-color"}
							color={base["body-font-color"]}
							defaultColor={defaultBase["body-font-color"]}
						/>
					}
				/>
				<BrandElement
					path={basePath + ".body-font-color-2"}
					title={<Translate value="app-brand-colour-body-font2-title" />}
					desc={<Translate value="app-brand-colour-default-desc" />}
					rightPanel={
						<BrandColor
							path={basePath + ".body-font-color-2"}
							color={base["body-font-color-2"]}
							defaultColor={defaultBase["body-font-color-2"]}
						/>
					}
				/>
			</div>

			<FullBar
				className="tabContentTitleRow"
				left={
					<p className="h7">
						<Translate value="app-brand-modal-tab-colors-alert-section-title" />
					</p>
				}
			/>

			<div className="brandElementsContainer">
				<BrandElement
					path={basePath + ".success-brand-color"}
					title={<Translate value="app-brand-colour-success-title" />}
					desc={<Translate value="app-brand-colour-success-desc" />}
					rightPanel={
						<BrandColor
							path={basePath + ".success-brand-color"}
							color={base["success-brand-color"]}
							defaultColor={defaultBase["success-brand-color"]}
						/>
					}
				/>
				<BrandElement
					path={basePath + ".warning-brand-color"}
					title={<Translate value="app-brand-colour-warning-title" />}
					desc={<Translate value="app-brand-colour-warning-desc" />}
					rightPanel={
						<BrandColor
							path={basePath + ".warning-brand-color"}
							color={base["warning-brand-color"]}
							defaultColor={defaultBase["warning-brand-color"]}
						/>
					}
				/>
				<BrandElement
					path={basePath + ".error-brand-color"}
					title={<Translate value="app-brand-colour-error-title" />}
					desc={<Translate value="app-brand-colour-error-desc" />}
					rightPanel={
						<BrandColor
							path={basePath + ".error-brand-color"}
							color={base["error-brand-color"]}
							defaultColor={defaultBase["error-brand-color"]}
						/>
					}
				/>
				<BrandElement
					path={basePath + ".error-brand-color-darken"}
					title={<Translate value="app-brand-colour-error-darken-title" />}
					desc={<Translate value="app-brand-colour-error-darken-desc" />}
					rightPanel={
						<BrandColor
							path={basePath + ".error-brand-color-darken"}
							color={base["error-brand-color-darken"]}
							defaultColor={defaultBase["error-brand-color-darken"]}
						/>
					}
				/>
			</div>
		</div>
	);
};

Colours.propTypes = {
	localBrand: PropTypes.object,
	brand: PropTypes.object,
	resetTabData: PropTypes.func,
	resellerName: PropTypes.string,
};

Colours.defaultProps = {};

export default withRouter(
	connect(
		(state) => {
			return {
				localBrand: state.localBrand.data,
				//Only Reseller otherwise use getCurrentBrandFromState(state)
				brand: state.brand,
				resellerName: state.brand?.name,
			};
		},
		(dispatch) => bindActionCreators({}, dispatch)
	)(Colours)
);
